export function getBearerToken(): string {
    return sessionStorage.getItem('apiAccessToken-Value') || '';
}